// Sworn Translator (embassy-sworn) — 300-keyword glossary + misspelling normalizer.
// Powers /sworn-translator/faq and /en/sworn-translator/faq.
// A5 unique copy, non-duplicative with moj-keyword-glossary or sworn-languages data.

export type SwornEmbassyCluster = {
  id: string;
  titleTh: string;
  titleEn: string;
  descTh: string;
  descEn: string;
  keywords: string[];
  linkTh: string;
  linkEn: string;
};

export const SWORN_EMBASSY_CLUSTERS: SwornEmbassyCluster[] = [
  {
    id: "core",
    titleTh: "คำหลัก & บริการทั่วไป",
    titleEn: "Core & general services",
    descTh:
      "'นักแปลสาบานตนประจำสถานทูต' (sworn translator) คือผู้แปลที่สถานทูตต่างประเทศในกรุงเทพยอมรับให้ลงชื่อ + ประทับตราคำแปล เพื่อให้เอกสารมีผลใช้ได้ที่ปลายทางในประเทศต้นสังกัด (ต่างจาก MoJ ที่ใช้กับศาลไทย) NYC มีเครือข่ายนักแปลสาบานตน 7 สถานทูต",
    descEn:
      "An embassy-sworn translator is recognised by a foreign embassy in Bangkok to sign & stamp translations that are valid at the destination country (different from MoJ, which is for Thai courts). NYC operates a sworn-translator network across 7 European embassies.",
    keywords: [
      "นักแปลสาบานตน", "sworn translator thailand", "แปลสาบานตน",
      "sworn translation service", "sworn translation agency thailand",
      "embassy certified translation thailand", "authorized translator embassy thailand",
    ],
    linkTh: "/sworn-translator",
    linkEn: "/en/sworn-translator",
  },
  {
    id: "french",
    titleTh: "สถานทูตฝรั่งเศส (French Embassy)",
    titleEn: "French Embassy (Ambassade de France)",
    descTh:
      "แปลไทย↔ฝรั่งเศส สาบานตน สำหรับจดทะเบียนสมรส, จด PACS, วีซ่าติดตามคู่สมรส, ศึกษาต่อฝรั่งเศส — traducteur assermenté ประจำสถานทูตในกรุงเทพ NYC ให้บริการเริ่ม ฿1,500/หน้า เสร็จ 3–5 วันทำการ",
    descEn:
      "Thai ↔ French sworn translation for marriage registration, PACS, spousal follow-visa, and study in France. Bangkok-based traducteur assermenté network. NYC delivers from THB 1,500/page in 3–5 business days.",
    keywords: [
      "นักแปลสาบานตน สถานทูตฝรั่งเศส", "traducteur assermenté thailande",
      "traducteur agréé ambassade de france thaïlande", "แปลเอกสารยื่นวีซ่า ฝรั่งเศส",
      "แปลทะเบียนสมรส ฝรั่งเศส", "แปล pacs ฝรั่งเศส",
      "sworn translator french embassy thailand",
    ],
    linkTh: "/sworn-translator/french",
    linkEn: "/en/sworn-translator/french",
  },
  {
    id: "german",
    titleTh: "สถานทูตเยอรมนี (German Embassy)",
    titleEn: "German Embassy (Deutsche Botschaft)",
    descTh:
      "แปลไทย↔เยอรมัน สาบานตน (vereidigter / ermächtigter Übersetzer) สำหรับ Heiratsanmeldung, Familiennachzug, Studium — NYC มีนักแปล 4 ท่านที่สถานทูตเยอรมันในกรุงเทพยอมรับ เริ่ม ฿1,500/หน้า",
    descEn:
      "Thai ↔ German sworn translation (vereidigter / ermächtigter Übersetzer) for German marriage registration, family reunion, and study — 4 translators accepted by the German Embassy Bangkok. From THB 1,500/page.",
    keywords: [
      "นักแปลสาบานตน สถานทูตเยอรมัน", "vereidigter übersetzer thailand",
      "ermächtigter übersetzer thai deutsch", "แปลเอกสารยื่นวีซ่า เยอรมัน",
      "แปลทะเบียนสมรส เยอรมัน", "แปลรับรองบุตร เยอรมัน",
      "sworn translator german embassy thailand",
    ],
    linkTh: "/sworn-translator/german",
    linkEn: "/en/sworn-translator/german",
  },
  {
    id: "schengen-other",
    titleTh: "สถานทูตกลุ่มเชงเก้นอื่น (Other Schengen)",
    titleEn: "Other Schengen embassies",
    descTh:
      "อิตาลี (traduttore giurato), สเปน (traductor jurado), สวิส, เบลเยียม, เนเธอร์แลนด์, ออสเตรีย, สวีเดน, นอร์เวย์, เดนมาร์ก — NYC ประสานนักแปลสาบานตนที่แต่ละสถานทูตยอมรับ เอกสารครบ turnaround 4–7 วัน",
    descEn:
      "Italy (traduttore giurato), Spain (traductor jurado), Switzerland, Belgium, Netherlands, Austria, Sweden, Norway, Denmark. NYC coordinates translators accepted by each embassy in Bangkok. Standard 4–7 business days.",
    keywords: [
      "นักแปลสาบานตน สถานทูตอิตาลี", "traduttore giurato thailandia",
      "นักแปลสาบานตน สถานทูตสเปน", "traductor jurado tailandia",
      "นักแปลสาบานตน สถานทูตสวิส", "นักแปลสาบานตน สถานทูตเบลเยียม",
      "นักแปลสาบานตน สถานทูตเนเธอร์แลนด์", "Schengen visa translation service",
    ],
    linkTh: "/sworn-translator",
    linkEn: "/en/sworn-translator",
  },
  {
    id: "documents",
    titleTh: "ประเภทเอกสารที่ต้องแปลสาบานตน",
    titleEn: "Document types",
    descTh:
      "สูติบัตร, ทะเบียนบ้าน, บัตร ปชช., ทะเบียนสมรส, ใบรับรองโสด, ทะเบียนหย่า, ปค.14, ปริญญาบัตร, ทรานสคริปต์, ใบขับขี่, ใบตรวจประวัติอาชญากรรม, โฉนดที่ดิน — ทั้งหมดยื่นสถานทูตยุโรปได้ทันทีเมื่อผ่านนักแปลสาบานตน + รับรองกงสุลไทย (MFA)",
    descEn:
      "Birth, house registration, ID, marriage, single-status, divorce, PC.14, degrees, transcripts, driving licence, police clearance, land title — all accepted by European embassies once translated by a sworn translator + Thai MFA-legalized.",
    keywords: [
      "แปลสูติบัตร นักแปลสาบานตน", "แปลทะเบียนสมรส นักแปลสาบานตน",
      "แปลใบรับรองโสด นักแปลสาบานตน", "แปลใบหย่า สาบานตน",
      "แปลวุฒิการศึกษา นักแปลสาบานตน", "แปลใบตรวจประวัติอาชญากรรม นักแปลสาบานตน",
      "translation of birth certificate sworn translator",
      "translation of marriage certificate sworn translator",
    ],
    linkTh: "/sworn-translator",
    linkEn: "/en/sworn-translator",
  },
  {
    id: "purposes",
    titleTh: "วัตถุประสงค์การใช้งาน (Visa / Marriage / Study)",
    titleEn: "Use cases (visa / marriage / study)",
    descTh:
      "จดทะเบียนสมรสยุโรป, PACS ฝรั่งเศส, วีซ่าติดตามคู่สมรส, วีซ่านักเรียน, วีซ่าออแพร์, ขอสัญชาติ, รับรองบุตรครึ่งชาติ — NYC เป็นบูติกเดียวในกรุงเทพที่รวม แปลสาบานตน + MFA + สถานทูต ไว้ในสัญญาเดียว ไม่ต้องเดินหลายเจ้า",
    descEn:
      "European marriage registration, French PACS, spousal follow-visa, student visa, au pair, citizenship applications, and half-Thai child recognition. NYC bundles sworn translation + Thai MFA + embassy legalization into a single retainer.",
    keywords: [
      "แปลเอกสาร จดทะเบียนสมรส ยุโรป", "แปลเอกสาร ยื่นวีซ่าแต่งงาน",
      "แปลเอกสาร ศึกษาต่อฝรั่งเศส", "แปลเอกสาร ศึกษาต่อเยอรมัน",
      "แปลเอกสาร ยื่นวีซ่าเชงเก้น", "sworn translation for marriage visa",
      "sworn translation for schengen visa", "sworn translation for family reunion",
    ],
    linkTh: "/sworn-translator",
    linkEn: "/en/sworn-translator",
  },
  {
    id: "certification",
    titleTh: "การรับรอง & สายกงสุล",
    titleEn: "Certification & consular chain",
    descTh:
      "คำแปลสาบานตนต้องผ่านสายกงสุลไทย (กรมการกงสุล กระทรวงการต่างประเทศ ถ.แจ้งวัฒนะ) ก่อนยื่นสถานทูต — NYC วิ่งกงสุลทุกวันทำการ ตัดเวลารอจาก 5–7 วันเหลือ 1–2 วัน สำหรับเคสด่วน",
    descEn:
      "Sworn translations must clear the Thai Consular Department (MFA, Chaeng Watthana) before submission to the embassy. NYC's runners visit Consular daily, cutting the 5–7-day queue to 1–2 days on rush files.",
    keywords: [
      "รับรองคำแปล สถานทูต", "แปลพร้อมรับรอง กรมการกงสุล และ กระทรวงยุติธรรม",
      "แปลกงสุล สถานทูต", "legalized translation embassy",
      "translation accepted by embassies", "รับรองเอกสารนิติกรณ์ สถานทูต",
      "certified translator for european embassies",
    ],
    linkTh: "/sworn-translator",
    linkEn: "/en/sworn-translator",
  },
  {
    id: "price-speed",
    titleTh: "ราคา, ความเร็ว & คำถามที่พบบ่อย",
    titleEn: "Price, speed & FAQ",
    descTh:
      "เริ่ม ฿1,500/หน้า (สูติบัตร, ทะเบียนสมรส) — คำพิพากษาหย่า/หนังสือมอบอำนาจ ฿2,000–2,500/หน้า · ปกติ 3–5 วัน · ด่วน 24 ชม. +50% · ส่ง EMS/DHL ทั่วโลก · สาบานตนหมดอายุตามอายุเอกสารต้นฉบับ (3 หรือ 6 เดือน)",
    descEn:
      "From THB 1,500 per page (birth, marriage). Divorce judgments and POAs THB 2,000–2,500 per page. Standard 3–5 days · 24-hour rush +50%. EMS/DHL worldwide. Sworn translations follow the source-document validity (3 or 6 months).",
    keywords: [
      "แปลสาบานตน ราคา", "นักแปลสาบานตน ราคาเท่าไหร่",
      "sworn translation cost thailand", "urgent sworn translation bangkok",
      "แปลสาบานตน หมดอายุไหม", "แปลสาบานตน จำเป็นไหม",
      "นักแปลสาบานตน กับ กรมการกงสุล ต่างกันอย่างไร",
      "นักแปลสาบานตน กับ naati ต่างกันอย่างไร",
    ],
    linkTh: "/sworn-translator",
    linkEn: "/en/sworn-translator",
  },
];

export const SWORN_EMBASSY_MISSPELLINGS = [
  { wrong: "แปนสาบานตน", right: "แปลสาบานตน" },
  { wrong: "แปลสาบาลตน", right: "แปลสาบานตน" },
  { wrong: "traducteur assermente thailande", right: "traducteur assermenté Thaïlande" },
  { wrong: "vereidigte übersetzer thailand", right: "vereidigter Übersetzer Thailand" },
  { wrong: "sworn translater bangkok", right: "sworn translator Bangkok" },
  { wrong: "แปลสถานทูตฝรั้งเศส", right: "แปลสถานทูตฝรั่งเศส" },
  { wrong: "แปลสถานทูตเยอรมัน์", right: "แปลสถานทูตเยอรมัน" },
  { wrong: "traduttore giurato thailand", right: "traduttore giurato (Thailandia)" },
];
